export var ModelDefinitionsDataset;
(function (ModelDefinitionsDataset) {
    ModelDefinitionsDataset["DEFAULT"] = "UK Biobank 500k, 470k, 450k, 300k";
    ModelDefinitionsDataset["WES_WGS"] = "UK Biobank 460k WES, 460k WGS";
})(ModelDefinitionsDataset || (ModelDefinitionsDataset = {}));
